/* eslint object-curly-newline:0 */
import Vue from 'vue';
import Vuex from 'vuex';
import { ParkingLotsApi } from '../../api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    devices: [],
  },
  mutations: {
    SET_DEVICES(state, devices) {
      state.devices = devices;
    },
  },
  actions: {
    GET_DEVICES({ commit }, id) {
      ParkingLotsApi.getMissingDevicesByParkingLotId(id)
        .then((resp) => {
          commit('SET_DEVICES', resp.data);
        });
    },
  },
});
